import { useMutation } from 'react-query';
import { getViaCepAdressAsync } from 'services/ViaCepService';

export const useGetViaCepAdress = () => useMutation(getViaCepAdressAsync);
